/** 已绑定手机号：11 位大陆手机号 */
const PHONE_RE = /^1\d{10}$/;

export const BIND_PHONE_PENDING_KEY = 'school_pc_bind_phone_pending';

export function isValidBoundMobile(value) {
  return PHONE_RE.test(String(value ?? '').trim());
}

/**
 * 根据资料判断是否仍需绑定手机
 * @param {Record<string, unknown>|null|undefined} row
 */
export function profileNeedsBindPhone(row) {
  if (!row || typeof row !== 'object') return true;

  const needBind = row.need_bind_mobile ?? row.needBindMobile;
  if (needBind === 1 || needBind === true || needBind === '1') return true;
  if (needBind === 0 || needBind === false || needBind === '0') return false;

  const isBind = row.is_bind_mobile ?? row.isBindMobile ?? row.has_mobile ?? row.hasMobile;
  if (isBind === 0 || isBind === false || isBind === '0') return true;
  if (isBind === 1 || isBind === true || isBind === '1') return false;

  const mpUserId = row.mp_user_id ?? row.mpUserId;
  if (mpUserId === 0 || mpUserId === '0') return true;

  const mobile = row.mobile ?? row.phone ?? row.mobile_phone ?? '';
  return !isValidBoundMobile(mobile);
}

/**
 * 仅用登录响应判断；无法确定时返回 null，需再拉 profile
 * @param {Record<string, unknown>|null|undefined} loginData
 * @returns {boolean|null}
 */
export function loginDataNeedsBindPhone(loginData) {
  if (!loginData || typeof loginData !== 'object') return null;

  const needBind = loginData.need_bind_mobile ?? loginData.needBindMobile;
  if (needBind === 1 || needBind === true || needBind === '1') return true;
  if (needBind === 0 || needBind === false || needBind === '0') return false;

  const mpUserId = loginData.mp_user_id ?? loginData.mpUserId;
  if (mpUserId === 0 || mpUserId === '0') return true;

  const info = loginData.admin_info || loginData.adminInfo;
  if (info && typeof info === 'object') {
    const infoMp = info.mp_user_id ?? info.mpUserId;
    if (infoMp === 0 || infoMp === '0') return true;

    const infoNeed =
      info.need_bind_mobile ??
      info.needBindMobile ??
      info.is_bind_mobile ??
      info.isBindMobile;
    if (infoNeed === 1 || infoNeed === true || infoNeed === '1') return true;
    if (infoNeed === 0 || infoNeed === false || infoNeed === '0') return false;

    if (info.mobile != null || info.phone != null) {
      return profileNeedsBindPhone(info);
    }
  }

  if (loginData.mobile != null || loginData.phone != null) {
    return profileNeedsBindPhone(loginData);
  }

  return null;
}
